import { render, staticRenderFns } from "./TicketsFiles.vue?vue&type=template&id=1ae8a713&scoped=true"
import script from "./TicketsFiles.vue?vue&type=script&lang=js"
export * from "./TicketsFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae8a713",
  null
  
)

export default component.exports